
if (!window.requestAnimationFrame) {
  window.requestAnimationFrame = (function() {
    return window.webkitRequestAnimationFrame ||
            window.mozRequestAnimationFrame ||
            window.oRequestAnimationFrame ||
            window.msRequestAnimationFrame ||
            function(/* function FrameRequestCallback */ callback, /* DOMElement Element */ element) {
              window.setTimeout(callback, 1000 / 60);
            };
  })();
}

function Timer() {
  this.tasks = [];
  this.isStop = true;
  this.loopFn = this.loopProcess.bind(this);
}
Timer.prototype = {
  addTask: function(task) {
    this.tasks.push(task);
    if (this.isStop === false) {
      return;
    }
    this.start();
  },
  start: function() {
    this.lastTime = new Date().getTime();
    this.isStop = false;
    this.loopFn();
  },

  loopProcess: function() {
    if (this.isStop) {
      return;
    }

    let timeNow = new Date().getTime();
    let elapse = timeNow - this.lastTime;
    let tasks = this.tasks;
    let execTasks = [];
    for (let i = 0; i < tasks.length; i++) {
      let task = tasks[i];
      task.remaining -= elapse;

      if (task.isDelete) {
        tasks.splice(i, 1);
        i--;
        continue;
      }
      if (task.remaining <= 0) {
        execTasks.push(task);
        task.remaining += task.interval;
      }
    }
    // Executing task will modify task count
    execTasks.forEach((task) => {
      task.handler();
    });
    this.lastTime = timeNow;

    if (tasks.length === 0) {
      this.isStop = true;
    }

    requestAnimationFrame(this.loopFn);
  },

  stop: function() {
    this.isStop = true;
  },
  release: function(isAuto) {
    isAuto = !!isAuto;
    if (isAuto === false) {
      this.tasks = [];
      return;
    }
    let tasks = this.tasks;
    for (let i = 0; i < tasks.length; i++) {
      let task = tasks[i];
      if (task.isAutoRelease) {
        tasks.splice(i, 1);
        i--;
      }
    }
  }
};

let timer = new Timer();
export default {
  releaseAutoTask: function() {
    timer.release(true);
  },
  once: function(fn, interval, isAutoRelease) {
    let task = {
      handler: function() {
        fn();
        this.release();
      },
      interval: interval,
      remaining: interval,
      isAutoRelease: isAutoRelease == null ? true : isAutoRelease,
      isDelete: false,
      release: function() {
        this.isDelete = true;
      }
    };
    timer.addTask(task);
    return task;
  },
  interval: function(fn, interval, isAutoRelease) {
    let task = {
      handler: fn,
      interval: interval,
      remaining: interval,
      isAutoRelease: isAutoRelease == null ? true : isAutoRelease,
      isDelete: false,
      release: function() {
        this.isDelete = true;
      }
    };
    timer.addTask(task);
    return task;
  }
};



// WEBPACK FOOTER //
// ./src/common/Timer.js